import './scss/pages/_mattress-selector.scss';
import './js/pages/mattress-selector';
